import { useEffect } from "react";
import type { Key } from "../game/round";

/** Physical keyboard support during a mission: digits, Backspace, Enter, and Escape to pass. */
export function useKeyboard(onKey: (key: Key) => void, enabled = true, onPass?: () => void) {
  useEffect(() => {
    if (!enabled) return;
    const handler = (e: KeyboardEvent) => {
      if (e.metaKey || e.ctrlKey || e.altKey) return;
      if (/^[0-9]$/.test(e.key)) onKey(e.key as Key);
      else if (e.key === "Backspace") onKey("⌫");
      else if (e.key === "Enter") {
        e.preventDefault();
        onKey("Go");
      } else if (e.key === "Escape" && onPass) {
        e.preventDefault();
        onPass();
      }
    };
    document.addEventListener("keydown", handler);
    return () => document.removeEventListener("keydown", handler);
  }, [onKey, enabled, onPass]);
}
